<template>
  <b-modal v-model="show" size="lg" @close="onCancel">
    <template v-slot:modal-title>{{ $t("commons.enc_dec_title") }}</template>
    <div class="my-2">
      <b-alert variant="info" :show="true" class="m-3 text-center">
        <em class="fa fa-check-circle mr-2"></em>
        {{ $t("commons.select_form_text") }}
      </b-alert>

      <div class="container">
        <div class="row">
          <div class="form-group col-md">
            <label for="val" class="font-weight-bold text-primary"> {{ $t("commons.plain_text") }} </label>
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input
                      type="radio"
                      aria-label="Radio button for plain text input"
                      name="encDecRadio"
                      :checked="!isEncoded"
                      :value="plainText"
                      @change="onChange($event)"
                      id="plainFormat"
                    />
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="plainText"
                  aria-label="Text input with radio button"
                  v-if="attribute.dataType != 'Text'"
                />

                <b-form-textarea
                  v-model="plainText"
                  class="textarea"
                  rows="25"
                  max-rows="25"
                  v-if="attribute.dataType == 'Text'"
                ></b-form-textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <label for="val" class="font-weight-bold text-primary"> {{ $t("commons.encoded_text") }} </label>
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input
                      type="radio"
                      aria-label="Radio button for encoded format"
                      name="encDecRadio"
                      :checked="isEncoded"
                      :value="encodedText"
                      @change="onChange($event)"
                      id="encFormat"
                    />
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="encodedText"
                  aria-label="Text input with radio button"
                  v-if="attribute.dataType != 'Text'"
                />

                <b-form-textarea
                  v-model="encodedText"
                  class="textarea"
                  rows="25"
                  max-rows="25"
                  v-if="attribute.dataType == 'Text'"
                ></b-form-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button
        type="submit"
        variant="primary"
        @click="onConfirm"
        v-text="$t('buttons.ok')"
      />
      <b-button
        type="reset"
        variant="danger"
        @click="onCancel"
        v-text="$t('buttons.cancel')"
      />
    </template>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      content: "",
      plainText: "",
      encodedText: "",
      isEncoded: false,
      result: "",
      attribute: {
        dataType: "String"
      },
    };
  },
  watch: {
    plainText: function (newVal, oldVal) {
      if (newVal) {
        this.content = newVal;
        this.setTextPlain();
      }
    },
  },
  methods: {
    open(attribute) {
      this.attribute = attribute;
      this.content = attribute.value;
      if (this.isBase64(this.content)) {
        this.isEncoded = true;
        this.setTextEncoded();
      } else {
        this.isEncoded = false;
        this.setTextPlain();
      }

      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onConfirm() {
      this.result == "plainFormat"
        ? this.resolve(this.plainText)
        : this.resolve(this.encodedText);
      this.show = false;
    },
    onCancel() {
      this.resolve(false);
      this.show = false;
    },
    onChange(event) {
      this.result = event.target.id;
    },
    setTextPlain() {
      this.plainText = this.content;
      this.encodedText = btoa(this.content);
    },
    setTextEncoded() {
      this.plainText = atob(this.content);
      this.encodedText = this.content;
    },
    isBase64(str) {
      let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
      if (str === "" || str.trim() === "") {
        return false;
      }
      try {
        return (btoa(atob(str)) == str) && (base64regex.test(str));
      } catch (err) {
        return false;
      }
    },
  },
};
</script>
